import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { USE_OF_FUNDS } from "@/lib/content";

export default function UseOfFunds() {
    return (
        <section
            id="funds"
            className="relative mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32"
            data-testid="use-of-funds"
        >
            <Reveal>
                <SectionLabel index="03">Use of Funds</SectionLabel>
            </Reveal>

            <Reveal delay={0.1}>
                <p className="max-w-3xl font-display text-2xl md:text-3xl font-light leading-snug text-white/90">
                    Capital is tightly focused on one clear milestone:{" "}
                    <span className="text-gold">
                        $2M in revenue from the $88 guided legacy plan within 12
                        months
                    </span>{" "}
                    while building the foundation for long-term generational
                    value.
                </p>
            </Reveal>

            {/* Table (desktop) */}
            <Reveal delay={0.15}>
                <div className="mt-14 hidden overflow-hidden border border-white/10 md:block">
                    <div className="grid grid-cols-12 border-b border-white/10 bg-white/[0.02] px-6 py-4">
                        <span className="col-span-3 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                            Category
                        </span>
                        <span className="col-span-1 text-right font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                            %
                        </span>
                        <span className="col-span-2 text-right font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                            Amount
                        </span>
                        <span className="col-span-6 pl-8 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                            Purpose
                        </span>
                    </div>
                    <StaggerGroup stagger={0.08}>
                        {USE_OF_FUNDS.map((row, i) => (
                            <StaggerItem key={row.category}>
                                <div
                                    className={`grid grid-cols-12 items-center px-6 py-6 transition-colors duration-300 hover:bg-white/[0.03] ${
                                        i !== USE_OF_FUNDS.length - 1
                                            ? "border-b border-white/10"
                                            : ""
                                    }`}
                                >
                                    <span className="col-span-3 font-medium text-white">
                                        {row.category}
                                    </span>
                                    <span className="col-span-1 text-right font-mono text-gold">
                                        {row.allocation}
                                    </span>
                                    <span className="col-span-2 text-right font-mono text-white">
                                        {row.amount}
                                    </span>
                                    <span className="col-span-6 pl-8 text-sm leading-relaxed text-white/60">
                                        {row.purpose}
                                    </span>
                                </div>
                            </StaggerItem>
                        ))}
                    </StaggerGroup>
                </div>
            </Reveal>

            {/* Cards (mobile) */}
            <div className="mt-10 space-y-4 md:hidden">
                {USE_OF_FUNDS.map((row) => (
                    <Reveal key={row.category}>
                        <div className="border border-white/10 p-6">
                            <div className="flex items-center justify-between">
                                <span className="font-medium text-white">
                                    {row.category}
                                </span>
                                <span className="font-mono text-gold">
                                    {row.allocation}
                                </span>
                            </div>
                            <p className="mt-1 font-mono text-sm text-white/70">
                                {row.amount}
                            </p>
                            <p className="mt-3 text-sm leading-relaxed text-white/60">
                                {row.purpose}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <p className="mt-10 max-w-3xl text-base leading-relaxed text-white/60">
                    This allocation is deliberately weighted toward the $88
                    acquisition engine and product polish required to prove
                    demand and unit economics in the first 12 months.
                </p>
            </Reveal>
        </section>
    );
}
